<template>
    <div class="SectionHeader">
        <div :class="headerTextClass">
            <template v-if="!isLoading">
                <!-- @slot Can be used in place of the `headerText` prop -->
                <slot>
                    <h4 class="SectionHeader__header-text">
                        {{ headerText }}
                    </h4>
                </slot>
                <slot name="subheader">
                    {{ subheader }}
                </slot>
            </template>
        </div>

        <!--
            Triggered when the header button is clicked
            @event header-action
            @property {object} event The click event
        -->
        <slot name="action">
            <RPButton
                v-if="showButton && !isLoading"
                class="SectionHeader__action-button"
                size="sm"
                @click.stop="e => $emit('header-action', e)"
            >
                {{ buttonText }}
            </RPButton>
        </slot>
    </div>
</template>
<script>
import RPButton from 'components/Basic/Buttons/RPButton.vue';
import stat from 'status/index';
import statusBuilder from 'status/statusBuilder';

export default {
    name: 'RPSectionHeader',
    components: {
        RPButton,
    },
    props: {
        showButton: {
            type: Boolean,
            default: false,
        },
        buttonText: {
            type: String,
            default: 'Submit',
        },
        headerText: {
            type: String,
            default: ''
        },
        subheader: {
            type: String,
            default: ''
        },
        status: {
            type: String,
            default: stat.STANDBY,
        },
    },
    computed: {
        isLoading(){
            return this.status === stat.LOADING;
        },
        headerTextClass(){
            return statusBuilder('SectionHeader__header', this.status);
        }
    }
};
</script>
<style lang="scss">
    .SectionHeader {
        display: flex;
        width: inherit;
        justify-content: space-between;
        margin-bottom: 1rem;

        &__header {
            @include loading(2rem, 13rem);
            display:flex;
            flex-direction: column;
            justify-content: space-evenly;

            &-text {
                font-weight: 600;
            }
        }

        &__action-button {
            margin: auto 0;
        }
    }
</style>

<docs>
```vue
<RPSectionHeader
    header-text="Header Text"
/>

<p>With button</p>

<RPSectionHeader
    header-text="Header Text"
    :show-button="true"
    button-text="Click Me!"
/>
```
</docs>
